import { render, staticRenderFns } from "./PanelPromotion.vue?vue&type=template&id=1b074328&scoped=true"
import script from "./PanelPromotion.vue?vue&type=script&lang=js"
export * from "./PanelPromotion.vue?vue&type=script&lang=js"
import style0 from "./PanelPromotion.vue?vue&type=style&index=0&id=1b074328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b074328",
  null
  
)

export default component.exports